/* eslint-disable arrow-body-style */
// eslint-disable-next-line no-unused-vars
import qs from 'query-string';
import axios from 'axios';
import CategoryFilterBuilder from '../fake-server/filters/category';
import CheckFilterBuilder from '../fake-server/filters/check';
import RadioFilterBuilder from '../fake-server/filters/range';
import ColorFilterBuilder from '../fake-server/filters/color';
import RangeFilterBuilder from '../fake-server/filters/price';

import { getCategories, getCategoryBySlug } from '../fake-server/endpoints/categories';
import {
    getDiscountedProducts,
    getFeaturedProducts,
    getLatestProducts,
    getPopularProducts,
    getProductBySlug,
    getProductsList,
    getRelatedProducts,
    getSuggestions, 
    getTopRatedProducts,
} from '../fake-server/endpoints/products';

const categoryCountCache = new Map();

const KNOWN_CATEGORY_COUNTS = {
    '1': 265, // Alat Pertukangan
    '2': 74,  // Bahan Bangunan
    '3': 201, // Cat
    '4': 29,  // Dapur
    '5': 1,   // Hardware
    '6': 2,   // Hobi
    '7': 166, // Kamar Mandi
    '8': 234, // Lantai & Dinding
    '9': 17,  // Listrik & Pencahayaan
    '10': 7,  // Peralatan Rumah Tangga
    '11': 7,  // Pintu & Jendela
    '12': 12, // Pipa Saluran Air
    '13': 0,  // Furniture
    '14': 0,  // Kawat dan Besi
};

async function getRealCategoryTotal(catId, rawData) {
    if (!catId || catId === 'all') return rawData?.total_item || 11321;
    const key = String(catId);

    // If the API already returned a filtered count < 1000, trust it!
    if (rawData?.total_item != null && rawData.total_item < 1000 && rawData.total_item > 0) {
        categoryCountCache.set(key, rawData.total_item);
        return rawData.total_item;
    }

    if (categoryCountCache.has(key)) {
        return categoryCountCache.get(key);
    }

    // Check pre-populated verified count
    if (KNOWN_CATEGORY_COUNTS[key] !== undefined) {
        // Trigger background live count probe
        axios.post(`${process.env.REACT_APP_HOST_API}/items-searching/page`, {
            page: 1,
            per_page: 500,
            kategori_id: catId,
        }).then((res) => {
            const count = Array.isArray(res.data?.response) ? res.data.response.length : null;
            if (count != null) {
                categoryCountCache.set(key, count);
            }
        }).catch(() => {});

        return KNOWN_CATEGORY_COUNTS[key];
    }

    // Dynamic probe
    try {
        const probeRes = await axios.post(`${process.env.REACT_APP_HOST_API}/items-searching/page`, {
            page: 1,
            per_page: 500,
            kategori_id: catId,
        });
        const realCount = Array.isArray(probeRes.data?.response) ? probeRes.data.response.length : rawData?.total_item || 0;
        categoryCountCache.set(key, realCount);
        return realCount;
    } catch (e) {
        return rawData?.total_item || 0;
    }
}

const homeProductsCache = {
    popularAll: null,
    popularByCat: new Map(),
    bestsellers: null,
};

function shuffleArray(arr) {
    const copy = [...arr];
    for (let i = copy.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy;
}

const shopApi = {
    /**
     * Returns array of categories.
     *
     * @param {object?} options
     * @param {number?} options.depth
     *
     * @return {Promise<Array<object>>}
     */
    getCategories: async (options = {}) => {
        /**
         * This is what your API endpoint might look like:
         *
         * https://example.com/api/categories.json?depth=2
         *
         * where:
         * - 2 = options.depth
         */
        // return fetch(`https://example.com/api/categories.json?${qs.stringify(options)}`)
        //     .then((response) => response.json());
        const result = await axios.post(`${process.env.REACT_APP_HOST_API}/warehouse/toko`, {
            page : 1,
            per_page : 10
        })
        if(result){
            return result.data.response
        }
        // This is for demonstration purposes only. Remove it and use the code above.
        // return getCategories(options);
    },
    /**
     * Returns category by slug.
     *
     * @param {string} slug
     * @param {object?} options
     * @param {number?} options.depth
     *
     * @return {Promise<object>}
     */
    getCategoryBySlug: async (categorySlug, options = {}) => {
        /**
         * This is what your API endpoint might look like:
         *
         * https://example.com/api/categories/power-tools.json?depth=2
         *
         * where:
         * - power-tools = slug
         * - 2           = options.depth
         */
        // return fetch(`https://example.com/api/categories/${slug}.json?${qs.stringify(options)}`)
        //     .then((response) => response.json());

        // This is for demonstration purposes only. Remove it and use the code above.
        const result = await axios.post(`${process.env.REACT_APP_HOST_API}/items-searching/page`, {
            page : 1,
            per_page : 100,
            kategori_id : categorySlug
        })
        return result.data.response
    },
    /**
     * Returns product.
     *
     * @param {string} slug
     *
     * @return {Promise<object>}
     */
    getProductBySlug: async (slug) => {
        /**
         * This is what your API endpoint might look like:
         *
         * https://example.com/api/products/screwdriver-a2017.json
         *
         * where:
         * - screwdriver-a2017 = slug
         */
        // return fetch(`https://example.com/api/products/${slug}.json`)
        //     .then((response) => response.json());

        // const product = 
        return await axios.get(`${process.env.REACT_APP_HOST_API}/items-searching/get/${slug}`)

        // return product.data.response
        // This is for demonstration purposes only. Remove it and use the code above.
        // return getProductBySlug(slug);
    },
    /**
     * Returns array of related products.
     *
     * @param {string}  slug
     * @param {object?} options
     * @param {number?} options.limit
     *
     * @return {Promise<Array<object>>}
     */
    getRelatedProducts: async (slug, options = {}) => {
        /**
         * This is what your API endpoint might look like:
         *
         * https://example.com/api/shop/products/screwdriver-a2017/related.json&limit=3
         *
         * where:
         * - screwdriver-a2017 = slug
         * - limit             = options.limit
         */
        // return fetch(`https://example.com/api/products/${slug}/related.json?${qs.stringify(options)}`)
        //     .then((response) => response.json());
        return await axios.post(`${process.env.REACT_APP_HOST_API}/items-searching/page`, {
            page : 1,
            per_page : 10
        })
        // This is for demonstration purposes only. Remove it and use the code above.
        // return getRelatedProducts(slug, options);
    },
    /**
     * Return products list.
     *
     * @param {object?} options
     * @param {number?} options.page
     * @param {number?} options.limit
     * @param {string?} options.sort
     * @param {Object.<string, string>?} filters
     *
     * @return {Promise<object>}
     */
    getProductsList: async (categorySlug, options = {}, filters = {}) => {
        const page = options.page || 1;
        const perPage = options.per_page || 20;

        const payload = {
            page: page,
            per_page: perPage,
        };
        const isSpecificCategory = categorySlug && categorySlug !== 'all';
        if (isSpecificCategory) {
            payload.kategori_id = categorySlug;
        }

        const result = await axios.post(`${process.env.REACT_APP_HOST_API}/items-searching/page`, payload);

        let totalItem = result?.data?.total_item != null ? result.data.total_item : 0;
        let totalPage = result?.data?.total_page != null ? result.data.total_page : 1;

        if (isSpecificCategory) {
            totalItem = await getRealCategoryTotal(categorySlug, result?.data);
            totalPage = Math.max(1, Math.ceil(totalItem / perPage));
        }

        return {
            items: Array.isArray(result?.data?.response) ? result.data.response : [],
            total_item: totalItem,
            total_page: totalPage,
            per_page: result?.data?.per_page || perPage,
            page: page,
        };
    },
    /**
     * Returns array of featured products.
     *
     * @param {object?} options
     * @param {number?} options.limit
     * @param {string?} options.category
     *
     * @return {Promise<Array<object>>}
     */
    getFeaturedProducts: (options = {}) => {
        /**
         * This is what your API endpoint might look like:
         *
         * https://example.com/api/shop/featured-products.json?limit=3&category=power-tools
         *
         * where:
         * - 3           = options.limit
         * - power-tools = options.category
         */
        // return fetch(`https://example.com/api/featured-products.json?${qs.stringify(options)}`)
        //     .then((response) => response.json());

        // This is for demonstration purposes only. Remove it and use the code above.
        return getFeaturedProducts(options);
    },
    /**
     * Returns array of latest products.
     *
     * @param {object?} options
     * @param {number?} options.limit
     * @param {string?} options.category
     *
     * @return {Promise<Array<object>>}
     */
    getLatestProducts: (options = {}) => {
        /**
         * This is what your API endpoint might look like:
         *
         * https://example.com/api/shop/latest-products.json?limit=3&category=power-tools
         *
         * where:
         * - 3           = options.limit
         * - power-tools = options.category
         */
        // return fetch(`https://example.com/api/latest-products.json?${qs.stringify(options)}`)
        //     .then((response) => response.json());

        // This is for demonstration purposes only. Remove it and use the code above.
        return getLatestProducts(options);
    },
    /**
     * Returns an array of top rated products.
     *
     * @param {object?} options
     * @param {number?} options.limit
     * @param {string?} options.category
     *
     * @return {Promise<Array<object>>}
     */
     getTopRatedProducts: (options = {}) => {
        return getTopRatedProducts(options);
    },
    /**
     * Returns an array of discounted products.
     *
     * @param {object?} options
     * @param {number?} options.limit
     * @param {string?} options.category
     *
     * @return {Promise<Array<object>>}
     */
    getDiscountedProducts: (options = {}) => {
        /**
         * This is what your API endpoint might look like:
         *
         * https://example.com/api/shop/discounted-products.json?limit=3&category=power-tools
         *
         * where:
         * - 3           = options.limit
         * - power-tools = options.category
         */
        // return fetch(`https://example.com/api/discounted-products.json?${qs.stringify(options)}`)
        //     .then((response) => response.json());

        // This is for demonstration purposes only. Remove it and use the code above.
        return getDiscountedProducts(options);
    },
    /**
     * Returns an array of most popular products.
     *
     * @param {object?} options
     * @param {number?} options.limit
     * @param {string?} options.category
     *
     * @return {Promise<Array<object>>}
    /**
     * Clear home cache if needed (e.g. pull to refresh)
     */
    clearHomeCache: () => {
        homeProductsCache.popularAll = null;
        homeProductsCache.popularByCat.clear();
        homeProductsCache.bestsellers = null;
    },

    /**
     * Returns an array of most popular products with caching and single-call optimization.
     *
     * @param {object?} options
     * @return {Promise<Array<object>>}
     */
    getPopularProducts: async (options = {}) => {
        try {
            const categoryId = options.kategori_id || options.categoryId || options.category;

            // If a specific category tab is selected
            if (categoryId) {
                const catKey = String(categoryId);
                if (homeProductsCache.popularByCat.has(catKey)) {
                    return homeProductsCache.popularByCat.get(catKey);
                }

                const result = await axios.post(`${process.env.REACT_APP_HOST_API}/items-searching/page`, {
                    page: options.page || 1,
                    per_page: options.limit || 20,
                    kategori_id: categoryId,
                });
                let items = Array.isArray(result.data?.response) ? result.data.response : [];
                items = shuffleArray(items);
                homeProductsCache.popularByCat.set(catKey, items);
                return items;
            }

            // General "Semua" tab - check cache first
            if (homeProductsCache.popularAll && homeProductsCache.popularAll.length > 0) {
                return homeProductsCache.popularAll.slice(0, options.limit || 24);
            }

            // Single fast fetch instead of heavy multi-request burst
            const result = await axios.post(`${process.env.REACT_APP_HOST_API}/items-searching/page`, {
                page: 1,
                per_page: 36,
            });

            let items = Array.isArray(result.data?.response) ? result.data.response : [];
            items = shuffleArray(items);
            homeProductsCache.popularAll = items;

            return items.slice(0, options.limit || 24);
        } catch (e) {
            console.error('Error in getPopularProducts:', e);
            return [];
        }
    },

    /**
     * Returns an array of bestsellers with caching and distinct products.
     *
     * @param {object?} options
     * @return {Promise<Array<object>>}
     */
    getBestsellers: async (options = {}) => {
        try {
            // Check cache
            if (homeProductsCache.bestsellers && homeProductsCache.bestsellers.length > 0) {
                return homeProductsCache.bestsellers.slice(0, options.limit || 7);
            }

            // Fetch page 2 so bestsellers don't overlap with page 1 popular products
            const result = await axios.post(`${process.env.REACT_APP_HOST_API}/items-searching/page`, {
                page: 2,
                per_page: 20,
            });

            let items = Array.isArray(result.data?.response) ? result.data.response : [];
            items = shuffleArray(items);

            // Prioritize an item with an image for the featured (index 0) card
            const withImageIndex = items.findIndex((item) => Boolean(item.image_url || item.photo));
            if (withImageIndex > 0) {
                const temp = items[0];
                items[0] = items[withImageIndex];
                items[withImageIndex] = temp;
            }

            homeProductsCache.bestsellers = items;
            return items.slice(0, options.limit || 7);
        } catch (e) {
            console.error('Error in getBestsellers:', e);
            return [];
        }
    },
    getBestsellerdown: async (options = {}) => {
        const result = await axios.post(`${process.env.REACT_APP_HOST_API}/items-searching/page`, {
            page: 1,
            per_page: 3,
        });
        return result.data.response;
    },
    /**
     * Returns search suggestions.
     *
     * @param {string}  query
     * @param {object?} options
     * @param {number?} options.limit
     * @param {string?} options.category
     *
     * @return {Promise<Array<object>>}
     */
    getSuggestions: async (query, warehouse_id, withFilter = false) => {
        /**
         * This is what your API endpoint might look like:
         *
         * https://example.com/api/search/suggestions.json?query=screwdriver&limit=5&category=power-tools
         *
         * where:
         * - query    = query
         * - limit    = options.limit
         * - category = options.category
         */
        // return fetch(`https://example.com/api/search/suggestions.json?${qs.stringify({ ...options, query })}`)
        //     .then((response) => response.json());

        // This is for demonstration purposes only. Remove it and use the code above.
        const result = await axios.post(`${process.env.REACT_APP_HOST_API}/items-searching/page`, {
            page : 1,
            per_page : 10,
            item_name : query,
            warehouse_id: warehouse_id
        })

        if(withFilter)
        {
            const filters = [
                new CategoryFilterBuilder('category', 'Categories'),
                new RangeFilterBuilder('price', 'Price'),
                new CheckFilterBuilder('brand', 'Brand'),
                new RadioFilterBuilder('discount', 'Discount'),
                new ColorFilterBuilder('color', 'Color'),
            ];

            let filterValues = {}

            let items = result.data.response.slice(0);

            filters.forEach((filter) => filter.makeItems(items, filterValues[filter.slug]));

            // Calculate items count for filter values.
            filters.forEach((filter) => filter.calc(filters));
            
            const page = 1;
            const limit = result.data.total_item;
            const sort = 'default';
            const total = items.length;
            const pages = Math.ceil(total / limit);
            const from = (page - 1) * limit + 1;
            const to = Math.max(Math.min(page * limit, total), from);

            items = items.sort((a, b) => {
                if (['name_asc', 'name_desc'].includes(sort)) {
                    if (a.name === b.name) {
                        return 0;
                    }

                    return (a.name > b.name ? 1 : -1) * (sort === 'name_asc' ? 1 : -1);
                }

                return 0;
            });

            const start = (page - 1) * limit;
            const end = start + limit;

            items = items.slice(start, end);
            let response = {
                page,
                limit,
                sort,
                total,
                pages,
                from,
                to,
                items,
                filters: filters.map((x) => x.build()),
            }


            return response;
        }
        else {
            return result.data.response
        }
        // const result = await axios.get(`http://localhost:5000/product`)
        // return result.data.products
        // return getSuggestions(query, options);
    }
};

export default shopApi;
